import { render, staticRenderFns } from "./AdminViewVolunteerWorksDialog.vue?vue&type=template&id=61584588&scoped=true"
import script from "./AdminViewVolunteerWorksDialog.vue?vue&type=script&lang=js"
export * from "./AdminViewVolunteerWorksDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminViewVolunteerWorksDialog.vue?vue&type=style&index=0&id=61584588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61584588",
  null
  
)

export default component.exports